import { useState, useMemo, useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Flex, Typography } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import PartyIcon from "./PartyIcon";
import { PiMoneyBold } from "react-icons/pi";
import { calculatePriceForParty } from "../common/helper";
import Popover from "./Popover";
import { MdStars } from "react-icons/md";
const CardList = ({ experiences, handleClick, partyType, partySize }) => {
  const [visibleExperiences, setVisibleExperiences] = useState([]);
  const [hasMore, setHasMore] = useState(true);

  const batchSize = 20;

  const [gap, setGap] = useState("8px"); // default to small gap (mobile)

  useEffect(() => {
    const updateGap = () => {
      if (window.innerWidth < 768) {
        setGap("8px"); // small gap for mobile
      } else {
        setGap("20px"); // large gap for desktop/laptop
      }
    };

    updateGap(); // Initial check
    window.addEventListener("resize", updateGap); // Listen for window resize

    return () => window.removeEventListener("resize", updateGap); // Clean up
  }, []);

  useMemo(() => {
    setVisibleExperiences(experiences.slice(0, batchSize));
    setHasMore(experiences.length > batchSize);
  }, [experiences]);

  const fetchMoreData = () => {
    const nextExperiences = experiences.slice(
      visibleExperiences.length,
      visibleExperiences.length + batchSize
    );

    if (nextExperiences.length === 0) {
      setHasMore(false);
      return;
    }

    setVisibleExperiences((prevExperiences) => [
      ...prevExperiences,
      ...nextExperiences,
    ]);
  };

  const isFeatured = (item) => {
    if(typeof item.advanceNoticeDays === "number" && item.advanceNoticeDays <= 3) {
      return true;
    }
    else if (typeof item.advanceNoticeDays === "string" && parseInt(item.advanceNoticeDays) <= 3) {
      return true;      
    }
    return false;
  } 

  return (
    <InfiniteScroll
      dataLength={visibleExperiences.length}
      next={fetchMoreData}
      hasMore={hasMore}
      endMessage={<p></p>}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-around",
          alignItems: "flex-start",
        }}
      >
        {visibleExperiences?.map((item, index) => (
          
          <div
            key={index}
            style={{
              width: "19rem",
              margin: gap,
              boxSizing: "border-box",
              overflow: "hidden",
              cursor: "pointer",
              borderRadius: 5,
              boxShadow: "0 6px 20px rgba(0, 0, 0, 0.15)",
              backgroundColor: "#fff",
            }}
            onClick={() => handleClick(item)}
          >
            <div
              style={{
                height: "12rem",
                width: "100%",
                position: "relative", // Make this container relative
              }}
            >
              <img
                src={item?.coverPhotos && item?.coverPhotos[0]?.image}
                style={{
                  height: "12rem",
                  width: "100%",
                  objectFit: "cover",
                }}
              />
              {item?.advanceNoticeDays <= 3 && (
                <Popover
                  title={"Featured Experience"}
                  content={
                    <div style={{ maxWidth: "450px" }}>
                      Hosted by featured guides and available to book on short
                      notice
                    </div>
                  }
                >
                  <MdStars
                    size={28}
                    color="#FA5705"
                    style={{
                      position: "absolute",
                      bottom: "0.5rem",
                      right: "0.5rem",
                      background: "white",
                      borderRadius: "50%",
                      cursor: "pointer",
                    }}
                  />
                </Popover>
              )}
            </div>

            <Flex
              gap={"medium"}
              justify="space-between"
              style={{ padding: "1rem" }}
              vertical
            >
              <Typography.Text style={{ minHeight: "4rem" }} strong>
                {item.experienceName}
              </Typography.Text>
              <Flex justify="flex-end" vertical>
                <Flex style={{ color: "grey" }} gap={"small"}>
                  <EnvironmentOutlined />
                  <Typography.Paragraph
                    style={{
                      paddingTop: "0.8rem",
                      fontWeight: "500",
                      color: "grey",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                  >
                    {item?.location?.formatedAdd}
                  </Typography.Paragraph>{" "}
                </Flex>
                <Flex style={{ color: "grey" }} gap={"small"} align="center">
                  <PartyIcon partyType={item.experienceType} />
                  <Typography.Text style={{ fontWeight: "500", color: "grey" }}>
                    {item.experienceType}
                  </Typography.Text>
                </Flex>
                <div style={{ height: "0.9rem", width: "0.9rem" }}></div>
                <Flex style={{ color: "grey" }} gap={"small"} align="center">
                  <div
                    style={{
                      height: "1rem",
                      width: "1rem",
                      marginTop: "-2px",
                      color: "grey",
                    }}
                  >
                    <PiMoneyBold />
                  </div>
                  <Typography.Text
                    style={{
                      fontWeight: "500",
                      height: "1rem",
                      color: "grey",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    $
                    {calculatePriceForParty(
                      item.experienceType,
                      item.baseSharedPrice,
                      item.basePrivatePrice,
                      item.extraPersonPrice,
                      partyType,
                      partySize
                    ).toFixed(2)}{" "}
                    (USD)
                  </Typography.Text>
                </Flex>
              </Flex>
            </Flex>
          </div>
        ))}

        {Array.from({ length: 12 }, (_, index) => (
          <div
            style={{
              width: "19rem",
              minWidth: "19rem",
              marginLeft: "20px",
              marginRight: "20px",
              overflow: "hidden",
            }}
            key={index}
          ></div>
        ))}
      </div>
    </InfiniteScroll>
  );
};

export default CardList;
